module.exports = __webpack_public_path__ + "static/img/program_03.6a7bc14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_03.jpg
// module id = B+IJ
// module chunks = 0